import { FC } from "react";
import { FaTiktok } from "react-icons/fa";
import styled from "styled-components";

const NoWrap = styled.div`
  align-items: center;
  display: flex;
  white-space: nowrap;
`;

const TikTokIcon = styled(FaTiktok)`
  width: 20px;
  height: 20px;
  color: white;
`;

type TikTokProps = {};

export const TikTok: FC<TikTokProps> = () => {
  return (
    <NoWrap>
      <a
        href="https://www.tiktok.com/@enefelthegame"
        target="_blank"
        rel="noopener noreferrer"
      >
        <TikTokIcon />
      </a>
    </NoWrap>
  );
};
